import { getFilteredPayload, getRequiredDataBagsForViewId } from 'helper/offlineAvailability';
import { initialState, OfflineAvailabilityStateType, RootStateType } from './offlineAvailability';

export const getOfflineAvailabilityState = (rootState: RootStateType): OfflineAvailabilityStateType => {
	return rootState.offlineAvailability || initialState;
};

/*
 * Check if all databags for the current view are preloaded and ready
 * @param {RootState} rootState
 * @param {string} DataBagKeyType
 * @param {Object?} additionalPayload
 */
export const getIsDataBagAvailable = (
	rootState: RootStateType,
	DataBagKeyType: string,
	additionalPayload?: Object
): boolean => {
	if (!DataBagKeyType || DataBagKeyType.length === 0) {
		return false;
	}

	const state = getOfflineAvailabilityState(rootState);
	const selectedPayload = getFilteredPayload(DataBagKeyType, additionalPayload) || {};
	const required = getRequiredDataBagsForViewId(DataBagKeyType, selectedPayload);

	return required
		.filter((requiredDataBag: string) => typeof requiredDataBag === 'string')
		.every((requiredDataBag: string) => state[requiredDataBag] === true);
};
